export default __webpack_public_path__ + "static/media/litecampus-pin-blue.c9bc1c80.svg";